
<div class="cmp-contact-form-user-new">
  <ws-input
    v-model="value.email"
    name="email"
    class="full-width"
    :label="$t('uikit:profile.email.label')"
    :path="'scf.contact.email'"
    autocomplete="email"
    required
    :rules="[required, ...propStaticRules['email']]"
  />
  <ws-input
    v-model="value.name"
    name="name"
    class="full-width"
    :label="$t('uikit:address.name.label')"
    :path="'scf.contact.name'"
    autocomplete="name"
    :rules="[required, ...propStaticRules['name']]"
    :restrict="propRestriction['name']"
    required
  />
  <ws-input
    key="organisation"
    v-model="value.organisation"
    name="organisation"
    class="full-width"
    :label="$t('uikit:address.organisation.label')"
    :path="'scf.contact.organisation'"
    autocomplete="organization"
    optional-text
    :rules="propStaticRules['organisation']"
  />
  <ws-phone-input
    v-model="value.phone"
    name="phone"
    class="full-width"
    :placeholder="$t('uikit:profile.phone.label')"
    :path="'scf.contact.phone'"
    autocomplete="tel-local"
    required
    :rules="[required]"
    messages-overflow
  />
</div>
